module.exports = __webpack_public_path__ + "media/ITSM.2c3d73dc9e51c15907fb40430a27a89c.svg";